import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { Link } from 'foundations-components/transitional/components/Link';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
const ReplyRecommendationSettingsLink = ({
  children
}) => {
  const replyRecSettingsUrl = `${getFullUrl('app')}/customer-agent/${PortalIdParser.get()}/manage/reply-recommendations`;
  return /*#__PURE__*/_jsx(Link, {
    href: replyRecSettingsUrl,
    external: true,
    children: children
  });
};
export const ReplyRecUnsuccessfulReason = ({
  unsuccessfulReason
}) => {
  if (unsuccessfulReason === 'LOW_CONFIDENCE_SCORE') {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'hubspot-prosemirror.replyRecommendations.generationMessages.LOW_CONFIDENCE_SCORE_jsx',
      elements: {
        Link: ReplyRecommendationSettingsLink
      }
    });
  }
  if (unsuccessfulReason === 'INTENT_NOT_SUPPORTED') {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'hubspot-prosemirror.replyRecommendations.generationMessages.INTENT_NOT_SUPPORTED'
    });
  }
  if (unsuccessfulReason === 'UNEXPECTED_INTERNAL_ERROR') {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'hubspot-prosemirror.replyRecommendations.generationMessages.UNEXPECTED_INTERNAL_ERROR_jsx',
      elements: {
        Link: ReplyRecommendationSettingsLink
      }
    });
  }
  if (unsuccessfulReason === 'AGENT_OR_OUTGOING_MESSAGE') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.replyRecommendations.generationMessages.AGENT_OR_OUTGOING_MESSAGE"
    });
  }
  if (unsuccessfulReason === 'PORTAL_HAS_NO_DATA_SOURCES') {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'hubspot-prosemirror.replyRecommendations.generationMessages.PORTAL_HAS_NO_DATA_SOURCES_jsx',
      elements: {
        Link: ReplyRecommendationSettingsLink
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "hubspot-prosemirror.replyRecommendations.generationMessages.generic"
  });
};
ReplyRecUnsuccessfulReason.displayName = 'ReplyRecUnsuccessfulReason';